import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import SEO from "@/components/common/SEO";
import { CTAButton } from "@/components/common/CTA";
import { RouteLines } from "@/components/common/RouteLines";
import { nav } from "@/config/site";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found | Premier Global Sourcing" description="The page you are looking for could not be found." path="/404" />
      <section className="relative bg-navy text-white min-h-[80vh] flex items-center overflow-hidden" data-testid="notfound">
        <RouteLines className="pointer-events-none absolute inset-0 h-full w-full opacity-20" stroke="#4FD1CA" opacity={0.6} />
        <div className="container-page relative py-20 text-center flex flex-col items-center">
          <p className="font-heading font-extrabold text-copper text-[13px] tracking-[0.3em] uppercase">Error 404</p>
          <h1 className="mt-5 font-heading font-bold tracking-tight text-[64px] leading-[64px] lg:text-[96px] lg:leading-[96px]">Route not found</h1>
          <p className="mt-6 text-[17px] text-white/70 max-w-lg">
            The page you were looking for could not be located. Let us help you get back on route.
          </p>
          <div className="mt-9">
            <CTAButton to="/" className="bg-white text-navy hover:bg-white/90" icon={Home} data-testid="notfound-home">
              Back to home
            </CTAButton>
          </div>
          <nav className="mt-12 flex flex-wrap gap-x-6 gap-y-2 justify-center" aria-label="Helpful links">
            {nav.map((n) => (
              <Link key={n.path} to={n.path} className="text-[14px] text-white/70 hover:text-white inline-flex items-center gap-1">
                {n.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
